<template>
  <button v-if="actionButton" type="button" class="offer-action" @click="openDebtTypePicker()">
    Výpočet
  </button>
  <div v-else class="text-cta pointer" @click="openDebtTypePicker()">
    Výpočet
  </div>
</template>

<script>
export default {
  name: "ClientDtiInfoHandler",
  props: {
    bankKey: String,
    offer: Object,
    rules: [Array, null],
    actionButton: Boolean,
  },
  methods: {
    openDebtTypePicker () {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        payload: {
          bankKey: this.bankKey,
          offer: this.offer,
        },
        component: "ClientDtiInfoPopUp",
        rules: this.rules,
      });
    },
  },
}
</script>

<style scoped>
.offer-action {
  box-sizing: border-box;
  display: inline-flex;
  min-width: 104px;
  min-height: 40px;
  margin: 0;
  padding: 9px 14px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--app-border);
  border-radius: 10px;
  background: var(--app-surface-muted);
  color: var(--app-primary);
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, transform 0.18s ease;
}

.offer-action:hover {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
  transform: translateY(-1px);
}

</style>
